import { cssMerge } from '@volvo-cars/css/utils';

type TagButtonProps<C extends React.ElementType> = {
  children: React.ReactNode;
  isSelected?: boolean;
  as?: C;
} & React.ComponentPropsWithoutRef<C>;

export const TagButton = <C extends React.ElementType = 'button'>({
  children,
  isSelected = false,
  as,
  className,
  ...rest
}: TagButtonProps<C>) => {
  const Component = as || 'button';

  return (
    <Component
      className={cssMerge(
        isSelected ? 'button-filled' : 'button-outlined',
        className,
      )}
      data-size="small"
      {...rest}
    >
      {children}
    </Component>
  );
};
